/**
 * El aviso del currículum en el formulario público (SRH-332).
 *
 * Cuando el archivo se rechaza (no es PDF ni Word, pasa de 5 MB o falla al
 * subir) el motivo salía junto al campo, pero al enviar el formulario la
 * validación lo reemplazaba por «El curriculum vitae es requerido»: la persona
 * veía que se le pedía algo que ya había intentado dar, sin saber por qué no
 * contó. Aquí se conserva el motivo mientras no haya un archivo bueno.
 */

export interface CvRechazado {
  /** Cómo se llama el archivo que se intentó adjuntar. */
  nombre: string
  /** Por qué no se pudo, ya redactado para quien lo lee. */
  motivo: string
}

/** El aviso que acompaña a un archivo rechazado. */
export const avisoDeCvRechazado = ({ nombre, motivo }: CvRechazado): string => {
  const sinPunto = motivo.replace(/[.\s]+$/, '')
  return `No se adjuntó «${nombre}»: ${sinPunto[0]?.toLowerCase() ?? ''}${sinPunto.slice(1)}.`
}

/**
 * El error del campo al enviar, o nada si no falta el currículum.
 *
 * Con un archivo rechazado y ninguno bueno después, explica ese rechazo y no
 * dice solo que es requerido.
 */
export const errorDelCvAlEnviar = ({
  seExige,
  tieneArchivo,
  rechazado,
}: {
  seExige: boolean
  tieneArchivo: boolean
  rechazado: CvRechazado | null
}): string | undefined => {
  if (!seExige || tieneArchivo) return undefined
  if (rechazado) return avisoDeCvRechazado(rechazado)
  return 'El curriculum vitae es requerido'
}
